import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutPageTitle, LayoutSubHeader } from '@/features/layout';
import { Tabs, TabsList, TabsTrigger } from '@/shared/ui/Tabs';
import {
  WorksheetList,
  TemplateList,
  TemplatesLanding,
} from '@/features/template-manager';

type TemplatesTab = 'worksheets' | 'templates';

const pathToTab: Record<string, TemplatesTab> = {
  '/templates/worksheets': 'worksheets',
  '/templates/templates': 'templates',
};

export default function TemplatesPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab: TemplatesTab | undefined = pathToTab[location.pathname];

  const handleTabChange = useCallback(
    (value: string) => {
      navigate(`/templates/${value}`);
    },
    [navigate]
  );

  // Bare /templates is the landing page; the tabs belong to the list pages.
  if (!activeTab) {
    return (
      <>
        <LayoutPageTitle title="Templates" />
        <TemplatesLanding />
      </>
    );
  }

  return (
    <>
      <LayoutPageTitle title="Templates" />
      <LayoutSubHeader>
        <Tabs value={activeTab} onValueChange={handleTabChange}>
          <TabsList>
            <TabsTrigger value="worksheets">Worksheets</TabsTrigger>
            <TabsTrigger value="templates">Reports</TabsTrigger>
          </TabsList>
        </Tabs>
      </LayoutSubHeader>
      {activeTab === 'worksheets' && <WorksheetList />}
      {activeTab === 'templates' && <TemplateList />}
    </>
  );
}
